// Shared ICE server config used by every video call flow
// (1-on-1 VideoCallScreen, GroupVideoCallScreen, and GuestVideoScreen).
//
// Why TURN matters: peers on different networks (corporate, mobile, hotel WiFi)
// often sit behind symmetric NATs that STUN cannot punch through. Without a
// TURN relay, the connection silently fails after ICE gathering ends.
// Locally on one LAN this never trips; in production it is the dominant
// failure mode.
//
// We list multiple TURN endpoints so that if one is rate-limited, blocked, or
// down, the ICE agent can fall through to the next one.

export const ICE_SERVERS = {
  iceServers: [
    // Public STUN — fast, used when peers can connect directly across NATs.
    { urls: 'stun:stun.l.google.com:19302' },
    { urls: 'stun:stun1.l.google.com:19302' },

    // Primary TURN — Metered.ca account.
    {
      urls: [
        'turn:thealgorithm.metered.live:3478?transport=udp',
        'turn:thealgorithm.metered.live:3478?transport=tcp',
      ],
      username: 'metered',
      credential: 'MAU3h6fX7kqxxtluSamdUvcGHXsw8HQSJ4rZoYkotO-flMd0',
    },
    {
      urls: ['turn:thealgorithm.metered.live:443?transport=tcp'],
      username: 'metered',
      credential: 'MAU3h6fX7kqxxtluSamdUvcGHXsw8HQSJ4rZoYkotO-flMd0',
    },

    // Fallback TURN — Open Relay Project (free public TURN). Catches the case
    // where the primary's monthly credit is exhausted or its host is blocked
    // by a particular firewall. Ports 80 and 443 commonly traverse strict
    // corporate networks that block 3478.
    {
      urls: [
        'turn:openrelay.metered.ca:80',
        'turn:openrelay.metered.ca:443',
        'turn:openrelay.metered.ca:443?transport=tcp',
      ],
      username: 'openrelayproject',
      credential: 'openrelayproject',
    },
  ],
};
